import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedDestinations from './components/FeaturedDestinations';
import AboutPreview from './components/AboutPreview';
import BlogPreview from './components/BlogPreview';
import TipsGuides from './components/TipsGuides';
import Testimonials from './components/Testimonials';
import NewsletterCTA from './components/NewsletterCTA';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedDestinations />
        <AboutPreview />
        <BlogPreview />
        <TipsGuides />
        <Testimonials />
        <NewsletterCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;